import BaseApi from '@/api/Base/BaseApi'
import { CreateMergeNodePayload, ModelPipelineMergeNodeInfo, UpdateMergeNodePayload } from '@/api/MergeNode/types'

const ROOT = '/merge'

export default class MergeNodeApi extends BaseApi {
  getMergeNode(mergeNodeId: string) {
    return this.agent.get<ModelPipelineMergeNodeInfo>(`${ROOT}/${mergeNodeId}`)
  }

  updateMergeNode(payload: UpdateMergeNodePayload) {
    const { mergeNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${mergeNodeId}`, { ...rest })
  }

  createMergeNode(payload: CreateMergeNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/merge/create`, rest)
  }
}
